import React, { FC, ReactElement } from 'react'
import { Skeleton } from '@material-ui/lab'

export const InsightsLoader: FC = (): ReactElement => (
    <>
        <div className='id-loader id-stats'>
            <Skeleton className='idis-stat' />
            <Skeleton className='idis-stat' />
            <Skeleton className='idis-stat' />
            <Skeleton className='idis-stat' />
            <Skeleton className='idis-stat' />
        </div>
        <div className='id-loader id-stats id-insights-information'>
            <Skeleton className='idis-stat' />
            <Skeleton className='idis-stat' />
            <Skeleton className='idis-stat' />
        </div>
    </>
)
